import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { featuredReviews } from "@/lib/films";

export default function ReviewSpotlight() {
  const reviews = featuredReviews(5);

  return (
    <section className="container-portal mt-14 md:mt-20">
      <SectionHeading
        kicker="Reviews"
        title="热门影评推荐"
        description="来自影评人与研究者的深度解读，不止于剧情复述。"
        action={{ label: "查看全部专题", to: "/special/silent-current" }}
      />

      <div className="mt-7 grid grid-cols-1 gap-5 lg:grid-cols-[minmax(0,1.55fr)_minmax(0,1fr)]">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-200/70">
            {reviews.map(({ film, review }) => (
              <li key={`${film.id}-${review.title}`}>
                <Link
                  to={`/detail/${film.id}`}
                  className="group flex gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-5 cursor-pointer"
                >
                  <div className="flex w-12 shrink-0 flex-col items-center justify-center border-r border-background-200 pr-3">
                    <span className="font-label text-xl leading-none text-accent-600">
                      {review.score.toFixed(1)}
                    </span>
                    <span className="mt-1 text-[10px] text-foreground-500">评分</span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="line-clamp-1 text-[14.5px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {review.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">
                      {review.excerpt}
                    </p>
                    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                      <span className="text-accent-700">{film.title}</span>
                      <span className="h-2.5 w-px bg-background-300" />
                      <span>{review.author}</span>
                      <span className="hidden sm:inline">{review.role}</span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-up-line mt-1 shrink-0 text-foreground-300 transition-colors group-hover:text-accent-500" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative flex flex-col justify-between overflow-hidden rounded-lg bg-primary-900 p-6 text-background-100 md:p-7">
          <div className="pointer-events-none absolute -right-6 -top-4 select-none font-heading text-[120px] leading-none text-background-50/10">
            “
          </div>
          <div className="relative">
            <span className="label-caps text-[10px] text-accent-300">专题策划 · 第 12 期</span>
            <h3 className="mt-3 text-xl font-bold leading-snug text-background-50">
              静水深流：华语悬疑的「慢」与「狠」
            </h3>
            <p className="mt-3 text-[13px] leading-6 text-background-200/80">
              当反转不再稀奇，一批作品把镜头对准河流、档案与沉默。我们挑了四部代表作，聊聊这种慢为什么反而更狠。
            </p>
            <div className="mt-5 flex flex-wrap gap-2 text-[11px] text-background-100/70">
              <span className="rounded border border-background-50/20 px-2 py-0.5">4 部作品</span>
              <span className="rounded border border-background-50/20 px-2 py-0.5">6 篇影评</span>
              <span className="rounded border border-background-50/20 px-2 py-0.5">编辑精选</span>
            </div>
          </div>
          <Link
            to="/special/silent-current"
            className="relative mt-7 inline-flex w-fit items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap cursor-pointer"
          >
            进入专题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}